module.exports = __webpack_public_path__ + "img/exam_jan_2025_yiq0m2dr.865fbd21.jpg";